module.exports = __webpack_public_path__ + "static/media/card.6a01f2da.svg";